import { render, staticRenderFns } from "./equip-split.vue?vue&type=template&id=628026ac&scoped=true&"
import script from "./equip-split.vue?vue&type=script&lang=ts&"
export * from "./equip-split.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628026ac",
  null
  
)

export default component.exports